import { queryOptions } from "@tanstack/react-query";
import { fetchPlacesCity, fetchPlacesIndex } from "../../apis/places";
import type { PlacesCityParams } from "../../types/places";

const FIVE_MINUTES = 5 * 60 * 1000;

/**
 * The /places index — shared by the route's SSR loader and its component.
 *
 * @returns Query options keyed ["places"].
 */
export function placesIndexQueryOptions() {
  return queryOptions({
    queryKey: ["places"] as const,
    queryFn: fetchPlacesIndex,
    staleTime: FIVE_MINUTES,
  });
}

/**
 * One page of a city — shared by the route's SSR loader and its component.
 *
 * @param slug City slug.
 * @param params Page and filters from the URL.
 * @returns Query options keyed ["places", slug, params].
 */
export function placesCityQueryOptions(slug: string, params: PlacesCityParams) {
  return queryOptions({
    queryKey: ["places", slug, params] as const,
    queryFn: () => fetchPlacesCity(slug, params),
    staleTime: FIVE_MINUTES,
  });
}
